<h3 mat-dialog-title>{{ 'patient-intake.add-note' | translate }}</h3>
<mat-dialog-content>
  <form
    fxLayout="column"
    fxLayoutGap="10px"
    [formGroup]="overrideForm"
    [ngSwitch]="info.fieldType"
    (submit)="updateIntake()"
  >
    <div fxLayout="column" class="mt-3">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'common.note' | translate }}</mat-label>
        <textarea matInput name="note" formControlName="note"></textarea>
        <mat-hint>{{ 'patient-intake.add-note-hint' | translate }}</mat-hint>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
  <button mat-stroked-button type="button" mat-dialog-close>
    {{ 'common.cancel' | translate }}
  </button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="overrideForm.invalid"
    (click)="updateIntake()"
  >
    {{ 'common.add' | translate }}
  </button>
</mat-dialog-actions>
